import { endpoints } from "./config";
// import layersConstraint from "./layerConstraintConfig";

const reqConf = {
  server: [],

  requests: [
    // {
    //   key: "mapService",
    //   fullUrl:
    //     "https://test.giscon.de/AGS107_6080/arcgis/rest/services/Klima/Klimadaten/MapServer?f=pjson",
    //   initState: "toRequest",
    //   method: "GET",
    // },
    // {
    //   key: "config",
    //   fullUrl: "config.json",
    //   initState: "toRequest",
    //   method: "GET",
    //   bodyType: "JSON",
    // },
    {
      key: "config",
      fullUrl: endpoints.niklisParametersConfigUrl,
      initState: "toRequest",
      method: "GET",
      bodyType: "JSON",
      responseHandling: (response) =>
        response.json().then((data) => {
          if (
            !Array.isArray(data?.layersConstraint) ||
            data.layersConstraint.length === 0
          ) {
            throw new Error(
              "[klimaRequestConfig] Backend config missing or empty layersConstraint"
            );
          }

          const seen = new Map();
          const duplicates = [];
          data.layersConstraint.forEach((entry, i) => {
            const key = Object.keys(entry.constraints || {})
              .sort()
              .map((k) => `${k}=${entry.constraints[k]}`)
              .join("|");
            if (seen.has(key)) {
              const prev = seen.get(key);
              duplicates.push(
                `(id: ${prev.id}) matches (id: ${entry.id}) by Constraints: ${key}`
              );
            }
            seen.set(key, { i, id: entry.id, entry });
          });

          if (duplicates.length > 0) {
            console.warn(
              `[klimaRequestConfig] Found ${duplicates.length} duplicate constraint row(s) ` +
                `in ${data.layersConstraint.length} total.\n` +
                duplicates.map((d) => `  • ${d}`).join("\n")
            );
            // data.layersConstraint = Array.from(seen.values()).map(
            //   (v) => v.entry
            // );
          }

          return {
            configModus: "merge",
            deleteString: "undefined",
            arrayMerge: "merge",
            arraySkipIndex: "skip",
            arrayDeepMerge: true,
            widgetConfig: {
              mapFilter: {
                ...(data || {}),
                // layersConstraint,
              },
            },
          };
        }),
    },
  ],
};
export default reqConf;
